import Collapsible from 'react-collapsible';
import OpportunityTrigger from './opportunity_trigger';
import ReactTooltip from 'react-tooltip';
import VisibilityDecider from './visibilityDecider';
import {getOptions,getMessage} from './getOptions';
import NoIssuesFound from './noIssuesFound';

function CssImports(props){
   
   let items = props.report.offendersObj.list
   let options = getOptions(props,'ylb')
   let title = props.report.policy.label
   let msg = getMessage(options)
    msg = props.report.value

   let visibilityDecider = VisibilityDecider(props.config,options.is_critical,options.is_moderate,options.is_low,options.is_passed)

    return(

            <Collapsible lazyRender className={visibilityDecider} contentOuterClassName="panel" contentContainerTagName="div" triggerClassName="accordion" triggerOpenedClassName="accordion open" triggerTagName="button" trigger={["", <OpportunityTrigger classNameIndicators={options.classNameIndicators} msg={msg} is_critical={options.is_critical} is_low={options.is_low} is_moderate={options.is_moderate} is_passed={options.is_passed} arrowDirectionClass="fa fa-angle-down" title={title}/>]} triggerWhenOpen={["", <OpportunityTrigger classNameIndicators={options.classNameIndicators} msg={msg} is_critical={options.is_critical} is_low={options.is_low} is_moderate={options.is_moderate} is_passed={options.is_passed} arrowDirectionClass="fa fa-angle-up" title={title}/>]}>
                
            <p>It’s bad for performance to use @import because CSS files don't get downloaded in parallel. You should use &lt;link rel='stylesheet' href='a.css'&gt; instead.</p>

            { Object.keys(items).length > 0 &&
            <table className="table table-striped table-responsive">
                <thead>
                <tr>
                    <th scope="col">File</th>
                    <th scope="col">CSS</th>
                    <th scope="col">Column</th>
                    <th scope="col">Line</th>               
                </tr>
                </thead>
                <tbody>

            {Object.keys(items).map((key, index) => {
              return (
                        <tr key={index}>
                          <td>
                              { items[index]['file'] === '[inline CSS]' ? <span>{items[index]['file']}</span> : <a data-tip={items[index]['file']} target="_blank" href={items[index]['file']}>{items[index]['file']}</a>
                              }
                          </td>
                          <td>
                              { items[index]['css'] === '[inline CSS]' ? <span>{items[index]['css']}</span> : <a data-tip={items[index]['css']} target="_blank" href={items[index]['css']}>{items[index]['css']}</a>
                              }
                          </td>
                          <td>{items[index]['column']}</td>
                          <td>{items[index]['line']}</td>
                        </tr>
              );
            })} 
                </tbody>
          </table>
          }
          { Object.keys(items).length === 0 &&
              <NoIssuesFound/>
          }           
            <ReactTooltip place="right" multiline={true} clickable={true} delayHide={1000} />
          </Collapsible>
          
    )
}

export default CssImports